export const checkIfWebPlatform = () => {
    return !window.Android && !window.ios
}

export const checkIfIosPlatform = () => /iPad|iPhone/.test(navigator.userAgent)

export const checkIfAndroidPlatform = () => /Android/.test(navigator.userAgent)
